import { render, staticRenderFns } from "./Endorsements.vue?vue&type=template&id=56d2b608"
import script from "./Endorsements.vue?vue&type=script&lang=ts"
export * from "./Endorsements.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports